import { getErrorMessage, getRequestId } from "@onadssuper/api-client";
import { AlertTriangle } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "./button";

export const EmptyState = ({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}) => (
  <div className="flex flex-col items-center justify-center gap-2 px-6 py-12 text-center">
    {icon && <div className="mb-1 text-subtle">{icon}</div>}
    <p className="font-medium">{title}</p>
    {description && <p className="max-w-sm text-sm text-muted">{description}</p>}
    {action && <div className="mt-3">{action}</div>}
  </div>
);

/** Shows what went wrong plus the request ID to quote to support. */
export const ErrorState = ({
  error,
  onRetry,
  title = "Something went wrong",
}: {
  error: unknown;
  onRetry?: () => void;
  title?: string;
}) => {
  const requestId = getRequestId(error);
  return (
    <div role="alert" className="flex flex-col items-center gap-2 px-6 py-12 text-center">
      <AlertTriangle className="size-6 text-danger" aria-hidden />
      <p className="font-medium">{title}</p>
      <p className="max-w-sm text-sm text-muted">{getErrorMessage(error)}</p>
      {requestId && <p className="font-mono text-xs text-subtle">Reference: {requestId}</p>}
      {onRetry && (
        <Button variant="secondary" size="sm" className="mt-2" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
};
